var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _PICSelector_onlyRunThisOnce, _PICSelector_onlyRunThisOnceTheSecond;
var PICSelector_1;
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { property, query, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { html, css } from 'lit';
import { customElement, stringDecoder, numberDecoder, booleanDecoder, PICText, PIC, PICSuggestion, enumConverter, PICOptionGroup, fetchApiData } from '../Internals';
var MatchMode;
(function (MatchMode) {
    MatchMode["StartsWith"] = "StartsWith";
    MatchMode["Contains"] = "Contains";
    MatchMode["StartsWithContains"] = "StartsWithContains"; /* SWC searches first for starts with, then contains */
})(MatchMode || (MatchMode = {}));
var MatchPriority;
(function (MatchPriority) {
    MatchPriority["None"] = "None";
    MatchPriority["Val"] = "Val";
    MatchPriority["ValSub"] = "ValSub";
    MatchPriority["ValOnly"] = "ValOnly";
    MatchPriority["ValSubOnly"] = "ValSubOnly"; // matches only ValSub
})(MatchPriority || (MatchPriority = {}));
let PICSelector = PICSelector_1 = class PICSelector extends PICText {
    set selectedOption(iOpt) {
        this.selectedOption_ = iOpt;
    }
    get selectedOption() {
        return this.selectedOption_;
    }
    constructor() {
        super();
        this.selectType_ = 'spinner';
        this.rows_ = 10;
        this.onlyvalid_ = false;
        this.fitcontent_ = false;
        this.alignRight_ = false;
        this.matchMode = MatchMode.StartsWith;
        this.matchPriority = MatchPriority.None;
        this.useRest = false;
        this.curVal = '';
        this.updateStarted = false;
        this.hasEllipsis = false;
        this.optionsDataParsed = false;
        _PICSelector_onlyRunThisOnce.set(this, false);
        _PICSelector_onlyRunThisOnceTheSecond.set(this, false);
    }
    static get styles() {
        const defaultStyle = css `
        :host {
            --pic-selectorMenuArrowDownColor: var(--pic-onSurfaceMediumColor);
            --pic-arrowBottom: 0px;
            --pic-selectorBorderOffset: 2px;
            --pic-selectorDensityLowInputHeight: var(--pic-densityLowInputHeight);
            --pic-selectorDensityMediumInputHeight: var(--pic-densityMediumInputHeight);
            --pic-selectorDensityHighInputHeight: var(--pic-densityHighInputHeight);
            --pic-selectorDensityInlineInputHeight: var(--pic-densityInlineInputHeight);
        }
        .inner-input select {
            background-color: black;
            color: white;
        }
        .inner-input-default {
            display: flex;
            justify-content: space-between;
            user-select: none;
            cursor: default;
        }
        .inner-inputLabel{
          user-select: none;  
        }
        .inner-input-default.low {
            height: var(--pic-selectorDensityLowInputHeight);
            --pic-arrowBottom: calc( ( var(--pic-selectorDensityLowInputHeight) - 24px ) / 2);
        }
        .inner-input-default.medium {
            height: var(--pic-selectorDensityMediumInputHeight);
            --pic-arrowBottom: calc( ( var(--pic-selectorDensityMediumInputHeight) + 2px - 24px ) / 2);
        }
        .inner-input-default.high {
            height: var(--pic-selectorDensityHighInputHeight);                
            --pic-arrowBottom: calc( ( var(--pic-selectorDensityHighInputHeight) + 2px - 20px ) / 2);
            cursor: default;
        }
        .inner-input-default.inline {
            height: var(--pic-selectorDensityInlineInputHeight);                
        }
        .inner-inputLabel.disabled{
            pointer-events:none;
        }
        .inner-input.disabled{
            pointer-events: none;
            border-color: var(--pic-innerInputBorderDisabledColor);
            background-color: var(--pic-surfaceColor);
            color: var(--pic-disabledColor);
        }
        .inner-input.invalid { 
            border-color: var(--pic-innerInputBorderInvalidColor);
            border-width: 2px;
            padding-left: 13px;
            padding-right: 0;
        }
        .arrowdown::after {
            content: '\u{F035D}';
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--pic-selectorMenuArrowDownColor);
            bottom: var(--pic-arrowBottom);
            margin-top: 1px;
            }
        .arrowup::after {
            content: '\u{F0360}';
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--pic-selectorMenuArrowDownColor);
            bottom: var(--pic-arrowBottom);
            margin-top: 1px;
        }
        .inline-column {
            display: flex;
            flex-direction: column;
        }
        .textoverflow p{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        select.inner-input-default:focus {
            padding-left: 14px;
            padding-right: 1px;
            border: 1px solid var(--pic-innerInputBorderColor);
            outline: 1px solid var(--pic-innerInputBorderFocusColor);
        }
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
        `;
    }
    get submitValue() {
        if (this.eType != 'old') {
            if (!this.submitVal_) {
                //Multiselect spinner can deselect all, and then return blank                
                if (this.selectType_ === 'selectmultiple')
                    return '';
                if (this.selectedOption_)
                    this.submitVal_ = this.selectedOption_.key;
                else
                    this.submitVal_ = '';
            }
            else {
                return this.submitVal_;
            }
        }
        else {
            if (!this.submitVal_) {
                if (this.selectorElem instanceof HTMLSelectElement) {
                    if (this.selectorElem.selectedOptions[0]) {
                        if (this.selectorElem.selectedOptions[0].value)
                            return this.selectorElem.selectedOptions[0].value;
                        return this.selectorElem.selectedOptions[0].text;
                    }
                    return '';
                }
                else {
                    return '';
                }
            }
        }
        return this.submitVal_;
    }
    get inModal() {
        var _a;
        return ((_a = this.getRootNode().firstElementChild) === null || _a === void 0 ? void 0 : _a.nodeName) === 'PIC-MODAL';
    }
    connectedCallback() {
        super.connectedCallback();
        this.eType == 'default' || this.eType == 'text' ? this.eType = 'selection' : this.eType = 'old';
        this.requestUpdate();
    }
    handleCMDUpdate(e) {
        var _a;
        let cmd = e.detail;
        if (e.detail.data)
            cmd = e.detail.data;
        if (typeof cmd === 'string') {
            this.setValue(cmd);
            this.requestUpdate();
        }
        if (typeof cmd === 'object') {
            let newOptions = [];
            if (cmd.Options) {
                newOptions = cmd.Options;
                this.selectedOption_ = undefined;
                this.submitVal_ = '';
                this.value = '';
                if (this.menu)
                    this.menu.clearSelection();
                if (!this.optionContainer) {
                    this.optionContainer = new PICOptionGroup();
                    this.optionContainer.componentRef = this;
                    this.appendChild(this.optionContainer);
                }
                (_a = this.optionContainer) === null || _a === void 0 ? void 0 : _a.swapOptions(newOptions, Number(e.detail.data.Minchars), e.detail.data.Progpath, e.detail.data.Parms);
            }
        }
    }
    setValue(value) {
        value = value.toLowerCase();
        let found = this.options.find(option => option.key === value);
        if (found) {
            this.selectedOption_ = found;
            this.submitVal_ = value;
        }
    }
    changeHandler(e) {
        if (this.selectedOption_)
            this.submitVal_ = this.selectedOption_.key;
        if (this.boundFldElm) {
            if (this.boundFldElm instanceof PICSuggestion || this.boundFldElm instanceof PICSelector_1) {
                if (this.boundFldElm.optionContainer) {
                    /*this.boundFldElm.optionContainer.parms_ = this.submitValue*/
                    this.boundFldElm.optionContainer.getAndParseOptions(true, true, this.selectedOption);
                }
            }
            else {
                this.boundFldElm.value = this.submitValue;
            }
        }
        this.validateSubmit();
        return super.changeHandler(e);
    }
    keyHander(e) {
        var _a, _b;
        switch (e.key) {
            case ' ':
                e.preventDefault();
            //pass on to enter handler     
            case 'Enter':
                if (!this.menu.isHidden) {
                    this.selectedOption = this.menu.selectMarked();
                    this.changeHandler(e);
                }
                this.menu.isHidden = !this.menu.isHidden;
                this.menuSpinnerFocusHandler();
                this.requestUpdate();
                break;
            case 'Tab':
                this.menu.isHidden = true;
                this.inputField.classList.remove('arrowup');
                this.inputField.classList.add('arrowdown');
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (this.menu.isHidden) {
                    this.menu.isHidden = false;
                }
                this.menuSpinnerFocusHandler();
                this.menu.markNext();
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (this.menu.isHidden) {
                    this.menu.isHidden = false;
                }
                this.menuSpinnerFocusHandler();
                this.menu.markPrevious();
                break;
            case 'Escape':
                if (!this.menu.isHidden) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                ;
                this.menu.isHidden = true;
                this.inputField.classList.add('arrowdown');
                this.inputField.classList.remove('arrowup');
                break;
            case 'PageUp': {
                if (!this.menu.isHidden)
                    this.menu.markPrevious(10);
                break;
            }
            case 'PageDown': {
                if (!this.menu.isHidden)
                    this.menu.markNext(10);
                break;
            }
            case 'Home': {
                if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) > 0 && !this.menu.isHidden) {
                    //uncomment if it should select immediately, current only scrolls
                    //this.updateSelectedMenuItem(e, 0, this.options[0])
                    this.menu.markFirst();
                }
                break;
            }
            case 'End': {
                if (((_b = this.options) === null || _b === void 0 ? void 0 : _b.length) > 0 && !this.menu.isHidden) {
                    //uncomment if it should select immediately, current only scrolls
                    //this.updateSelectedMenuItem(e, this.options.length-1, this.options[this.options.length-1])
                    this.menu.markLast();
                }
                break;
            }
            default:
                this.handleInput(e);
                break;
        }
    }
    updateSelectedMenuItem(e, itemNumber, selectedItem) {
        if (this.menu)
            this.menu.shouldHide = false;
        this.selectedOption = selectedItem;
        this.menu.curSelected = itemNumber;
        this.changeHandler(e);
        this.menuSpinnerFocusHandler();
        this.requestUpdate();
    }
    handleInput(e) {
        var _a, _b, _c;
        this.curVal += e.key;
        setTimeout(() => { this.curVal = ''; }, 1000);
        //do not match most common meta-keys with keys in options
        //could also be moved to prev function
        switch (e.key) {
            case 'Shift':
            case 'Alt':
            case 'AltGraph':
            case 'Meta':
            case 'Control':
            case 'Insert':
            case 'Delete':
                return;
        }
        const cval = escapeRegExp(this.curVal);
        const startsWith = new RegExp('^' + cval, 'i');
        const contains = new RegExp(cval, 'i');
        //const startsWithOrContains = new RegExp(`^${cval}|${cval}`, 'i')
        /*  Scenarios:
            StartsWith / Contains -> find first
            StartsWithContains -> find first StartsWith, then Contains
            -- if found but not prio, check rest still
        */
        //TODO..... could just work like normal select, 2+2 selects 2nd option with 2, not 22.... mhm?
        if (this.selectType_ === 'spinner') {
            /* Special case, to make the default handle like... normal select  - could exapnd this*/
            let curSelOpt = this.options[this.menu.curSelected];
            if (this.matchMode === MatchMode.StartsWith && this.matchPriority === MatchPriority.None && (curSelOpt.val.match(startsWith) || ((_a = curSelOpt.valsub) === null || _a === void 0 ? void 0 : _a.match(startsWith)))) {
                //Mark next valid element, otherwise start list over
                let nxtEl = this.options[this.menu.curSelected + 1];
                if (nxtEl && (nxtEl.val.match(startsWith) || ((_b = nxtEl.valsub) === null || _b === void 0 ? void 0 : _b.match(startsWith)))) {
                    this.curVal = '';
                    this.menu.markNext();
                }
                else {
                    let curSel = this.menu.curSelected;
                    for (let i = 0; i < curSel; i++) {
                        const curOpt = this.options[i];
                        if (curOpt.val.match(startsWith) || ((_c = curOpt.valsub) === null || _c === void 0 ? void 0 : _c.match(startsWith))) {
                            this.curVal = '';
                            this.menu.jumpTo(i);
                            return;
                        }
                    }
                }
                return;
            }
            /* ---------------------------- */
            //Find first match - StartsWith/Contains + ValOnly/ValSubOnly/None
            if ((this.matchMode === MatchMode.Contains || this.matchMode === MatchMode.StartsWith) && (this.matchPriority === 'None' || this.matchPriority === 'ValOnly' || this.matchPriority === 'ValSubOnly')) {
                const regexp2use = this.matchMode === MatchMode.Contains ? contains : startsWith;
                for (let i = 0; i < this.options.length; i++) {
                    const curOpt = this.options[i];
                    if ((this.matchPriority === 'ValOnly' || this.matchPriority === 'None') && curOpt.val && curOpt.val.match(regexp2use) != null) {
                        //this.updateSelectedMenuItem(e, i, curOpt)
                        //this.menu.scrollToMarked()
                        this.menu.jumpTo(i);
                        return;
                    }
                    if ((this.matchPriority === 'ValSubOnly' || this.matchPriority === 'None') && curOpt.valsub && curOpt.valsub.match(regexp2use) != null) {
                        //this.updateSelectedMenuItem(e, i, curOpt)
                        //this.menu.scrollToMarked()
                        this.menu.jumpTo(i);
                        return;
                    }
                }
            }
            else {
                const matches = [];
                //Create match hierarchy - StartsWithContains + Val/ValSub (ie also StartsWith + Val)
                //Can break out after -> first StartsWith, first Val/ValSub
                for (let i = 0; i < this.options.length; i++) {
                    const curOpt = this.options[i];
                    if (curOpt.valsub) {
                        if ((this.matchMode === MatchMode.StartsWith || this.matchMode === MatchMode.StartsWithContains) && curOpt.valsub.match(startsWith)) {
                            matches.push({ seq: i, option: curOpt, matchMode: 'StartsWith', matchPriority: 'ValSub' });
                        }
                        else if ((this.matchMode === MatchMode.Contains || this.matchMode === MatchMode.StartsWithContains) && curOpt.valsub.match(contains)) {
                            matches.push({ seq: i, option: curOpt, matchMode: 'Contains', matchPriority: 'ValSub' });
                        }
                    }
                    if ((this.matchMode === MatchMode.StartsWith || this.matchMode === MatchMode.StartsWithContains) && curOpt.val.match(startsWith)) {
                        matches.push({ seq: i, option: curOpt, matchMode: 'StartsWith', matchPriority: 'Val' });
                    }
                    else if ((this.matchMode === MatchMode.Contains || this.matchMode === MatchMode.StartsWithContains) && curOpt.val.match(contains)) {
                        matches.push({ seq: i, option: curOpt, matchMode: 'Contains', matchPriority: 'Val' });
                    }
                }
                //Find first in matches array according to prio
                let finalMatch;
                if (this.matchMode === MatchMode.StartsWith || this.matchMode === MatchMode.Contains) {
                    let valMatch = matches.find(y => y.matchPriority === 'Val');
                    let valSubMatch = matches.find(y => y.matchPriority === 'ValSub');
                    finalMatch = this.matchPriority === MatchPriority.Val
                        ? valMatch !== undefined
                            ? valMatch
                            : valSubMatch !== undefined
                                ? valSubMatch
                                : undefined
                        : valSubMatch !== undefined
                            ? valSubMatch
                            : undefined;
                }
                else { //StartsWithContains , s+v,vo,vs,vso,n . c+v,vo,vs,vso,n ...
                    if (this.matchPriority === MatchPriority.ValOnly) {
                        let valStartMatch = matches.find(y => y.matchMode === 'StartsWith' && y.matchPriority === 'Val');
                        let valContainMatch = matches.find(y => y.matchMode === 'Contains' && y.matchPriority === 'Val');
                        finalMatch = valStartMatch !== undefined
                            ? valStartMatch
                            : valContainMatch !== undefined
                                ? valContainMatch
                                : undefined;
                    }
                    else if (this.matchPriority === MatchPriority.ValSubOnly) {
                        let valStartMatch = matches.find(y => y.matchMode === 'StartsWith' && y.matchPriority === 'ValSub');
                        let valContainMatch = matches.find(y => y.matchMode === 'Contains' && y.matchPriority === 'ValSub');
                        finalMatch = valStartMatch !== undefined
                            ? valStartMatch
                            : valContainMatch !== undefined
                                ? valContainMatch
                                : undefined;
                    }
                    else { //StartsWithContains + none/val/valsub
                        let valStartMatch = matches.find(y => y.matchMode === 'StartsWith' && y.matchPriority === 'Val');
                        let valContainMatch = matches.find(y => y.matchMode === 'Contains' && y.matchPriority === 'Val');
                        let valSubStartMatch = matches.find(y => y.matchMode === 'StartsWith' && y.matchPriority === 'ValSub');
                        let valSubContainMatch = matches.find(y => y.matchMode === 'Contains' && y.matchPriority === 'ValSub');
                        // 2 priority scenarios (StartsWith always takes rank)
                        //SubVal: valSubStart > valStart > valSubContains > valContains
                        //Val: valStart > valSubStart > valContains > valSubContains
                        finalMatch = this.matchPriority === MatchPriority.None || this.matchPriority === MatchPriority.ValSub
                            ? valSubStartMatch !== undefined
                                ? valSubStartMatch
                                : valStartMatch !== undefined
                                    ? valStartMatch
                                    : valSubContainMatch !== undefined
                                        ? valSubContainMatch
                                        : valContainMatch !== undefined
                                            ? valContainMatch
                                            : undefined
                            : valStartMatch !== undefined
                                ? valStartMatch
                                : valSubStartMatch !== undefined
                                    ? valSubContainMatch
                                    : valContainMatch !== undefined
                                        ? valContainMatch
                                        : valSubContainMatch !== undefined
                                            ? valSubContainMatch
                                            : undefined;
                    }
                }
                if (finalMatch) {
                    //this.updateSelectedMenuItem(e, finalMatch.seq, finalMatch.option)
                    this.menu.jumpTo(finalMatch.seq);
                    return;
                }
                else
                    return;
            }
        }
        return undefined;
        function escapeRegExp(iStr) {
            return iStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }
    }
    focusHandler(mode) {
        if (mode === 'in') {
            this.showFullError = true;
            this.requestUpdate();
        }
        if (mode === 'out') {
            this.showFullError = false;
            this.requestUpdate();
        }
    }
    handleSpinnerChange(e) {
        var _a;
        let selOptions = e.target.selectedOptions;
        this.submitVal_ = '';
        for (let i = 0; i < selOptions.length; i++) {
            this.submitVal_ += ((_a = selOptions[i]) === null || _a === void 0 ? void 0 : _a.value) + ';';
        }
        this.submitVal_ = this.submitVal_.slice(0, -1);
        if (this.validState.length > 0) {
            this.validateSubmit();
        }
        if (this.selectType_ == 'selectmultiple') {
            this.value = this.submitVal_;
        }
        if ((this.selectType_ == 'selectmultiple' && !PIC.getInstance.ctrlKeyIsDown) || this.selectType_ == 'spinner') {
            this.updateStarted = true;
            super.changeHandler(e);
        }
    }
    handleMultiSelectBlur(e) {
        if (this.selectType_ == 'selectmultiple' && !this.updateStarted) {
            super.changeHandler(e);
        }
    }
    renderPlaceholderOption() {
        if (this.required_ && !this.value) {
            return html `<option value="" disabled selected hidden>${this.placeholder ? this.placeholder : 'Please select something'}</option>`;
        }
    }
    renderOption(iOpt, index, reverse) {
        let key, val, valSub, sel;
        key = iOpt.key;
        val = iOpt.val;
        valSub = iOpt.valsub !== 'undefined' && iOpt.valsub !== '' ? iOpt.valsub : undefined;
        sel = key == this.value;
        if (this.eType == 'old' && index === 0 && !this.initValue_) {
            if (this.value == '') {
                this.initValue_ = val;
            }
            else {
                this.initValue_ = this.value;
            }
        }
        return html `
            ${valSub != undefined
            ? html `<option ?selected=${sel} value=${key} style="font-weight: bold;padding-bottom: 20px; z-index: 1;">${val}</option>
                   <option disabled class="subval-option" style="font-size:12px; letter-spacing: .4px; color: var(--pic-onSurfaceHighColor); background-image: var(--pic-surfaceColor); margin-top: -16px;">${valSub}</option>`
            : html `<option ?selected=${sel} value=${key} style="font-weight: bold">${val}</option>`}
            
        `;
    }
    oldHandleKeyDown(_e) {
        /*if(this.initValue_ !== this.submitValue) this.enterSubmit(e);*/
    }
    renderSpinner(iMultiple = '') {
        const heightClass = { 'height': (iMultiple == 'multiple') ? (this.rows_ * 1.35) + 'rem' : '' };
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class="container">
                <label class=${classMap(this.getInputLabelClass())} for=${this.id}>${this.label}</label>              
                <select 
                    style=${styleMap(heightClass)}
                    class=${classMap(this.getInnerInputClass())}
                    name=${this.id} 
                    id="inner_selector" 
                    ?disabled=${this.disabled_}
                    ?multiple=${iMultiple == 'multiple'} 
                    @change=${this.handleSpinnerChange}
                    @keydown=${this.oldHandleKeyDown}
                    @blur=${this.handleMultiSelectBlur}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.focusHandler('out'); }}
                    >
                    ${this.renderPlaceholderOption()}
                    ${repeat(this.options, (item, index) => this.renderOption(item, index, true))}
                </select>
                ${this.renderErrIcon()}
                ${this.renderErr(this.showFullError)}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
    forceClose() {
        if (this.menu) {
            this.menu.isHidden = true;
            this.requestUpdate();
        }
    }
    menuSpinnerFocusHandler(e) {
        if (this.inputLabel && this.inputField) {
            if (this.density && this.density != 'old') {
                if (e) {
                    if (this.menu.isHidden) {
                        this.menu.isHidden = false;
                        this.menu.shouldHide = false;
                    }
                    else {
                        this.menu.isHidden = true;
                    }
                }
            }
        }
        this.requestUpdate();
    }
    willUpdate(_changedProperties) {
        if (PIC.WebWersion == '3') {
            if (this.menu && !this.menu.isHidden) {
                this.style.zIndex = '5';
            }
            else {
                this.style.zIndex = 'auto';
            }
        }
        if (this.fitcontent_) {
            if (!this.optionContainer) {
                return;
            }
            if (!this.optionContainer.options) {
                return;
            }
            if (this.oldOptLength !== this.optionContainer.options.size) {
                if (PIC.WebWersion == '3') {
                    if (this.selectType_ === 'spinner')
                        this.width = (40 + (this.optionContainer.getLengthOfLongestValue() * 10)) + 24 + 'px'; // arrow is 24px wide
                    else
                        this.width = (40 + (this.optionContainer.getLengthOfLongestValue() * 10)) + 'px';
                }
                else {
                    this.width = (10 + (this.optionContainer.getLengthOfLongestValue() * 9)) + 'px';
                }
            }
            this.oldOptLength = this.optionContainer.options.size;
        }
        //Select multiple does not have a menu, so do not trigger this
        if (this.inputField && this.selectType_ !== 'selectmultiple') {
            this.inputField.addEventListener('wheel', (e) => {
                if (this.menu && !this.menu.isHidden)
                    this.forceClose();
            });
        }
    }
    //This is used if fetching options from API and an initial value is set
    //Otherwise the fetch from PICOptionGroup is used
    fetchOptionsFromAPI(programPath, programParameters = '') {
        //Added because jsonpost api fails in java if body is empty
        if (programParameters === '')
            programParameters = 'internal-use-parameter';
        if (programParameters.length + 1 >= this.optionContainer.minChars_) {
            // Old api is just a single string for command
            let APIOptions = {
                postBody: programParameters
            };
            //TODO: streamline this and make it general, POST or GET ? Query params vs postbody
            if (this.useRest) {
                APIOptions.path = programPath;
                APIOptions.method = 'GET';
                delete APIOptions.postBody;
                delete APIOptions.systemId;
                programPath = '';
            }
            this.optionContainer.skipParsing = true;
            fetchApiData(programPath, APIOptions)
                .then((data) => {
                this.optionContainer.options.clear();
                data.forEach((o) => this.optionContainer.options.set(o.key, o));
                this.afterFetchOptionsFromAPI(data);
                this.optionContainer.skipParsing = false;
            })
                .catch(err => console.log('error:', err, 'programPath', programPath, 'programParameters', programParameters));
        }
    }
    parseOption(iElement) {
        var _a, _b, _c;
        let option = {
            key: iElement.hasAttribute('key') ? decodeURIComponent(iElement.getAttribute('key')) : '',
            val: iElement.hasAttribute('val') ? decodeURIComponent(iElement.getAttribute('val')) : '',
            valDisp: (_a = iElement.getAttribute('valDisp')) !== null && _a !== void 0 ? _a : undefined,
            valsub: iElement.hasAttribute('valsub') ? decodeURIComponent(iElement.getAttribute('valsub')) : '',
            valsubDisp: (_b = iElement.getAttribute('valsubDisp')) !== null && _b !== void 0 ? _b : undefined,
            action: (_c = iElement.getAttribute('action')) !== null && _c !== void 0 ? _c : undefined
        };
        return option;
    }
    parseOptionGroup() {
        let optionGroup = this.querySelector('pic-optiongroup');
        if (optionGroup && !this.optionsDataParsed) {
            // link to the dom object
            this.optionContainer = optionGroup;
            // look for children
            for (let child of optionGroup.children) {
                if (child.tagName === 'DATA') {
                    let option = this.parseOption(child);
                    optionGroup.options.set(option.key, option);
                }
            }
            // if has path fetch from api
            //This is currently needed to set values if the value is only available after the options api has been called
            //It means the api is called twice, which needs to be looked at later
            if (optionGroup.progpath_ && this.initValue_ != null && this.initValue_.length > 0) {
                this.fetchOptionsFromAPI(optionGroup.progpath_, optionGroup.parms_ === 'onchange' ? this.inputField.value : optionGroup.parms_);
            }
            // parsing is done, tell the component that
            // this.optionContainer = optionGroup;
            // to stop never ending parsing loop because updated will keep updating
            this.optionsDataParsed = true;
            this.afterParseOptionGroup();
        }
    }
    afterFetchOptionsFromAPI(data) {
        this.dataReady();
        this.requestUpdate();
    }
    afterParseOptionGroup() {
        this.dataReady();
        this.requestUpdate();
    }
    updated() {
        var _a;
        // only after multiple updates the options group will be visible to LIT, this is why there are so many settimouts
        this.parseOptionGroup();
        if (this.value) {
            if (this.menu && this.selectedOption) {
                let selIdx = this.options.indexOf(this.options.find(elm => elm.key === this.selectedOption.key));
                if (selIdx !== -1 && !__classPrivateFieldGet(this, _PICSelector_onlyRunThisOnceTheSecond, "f")) {
                    this.menu.curSelected = selIdx;
                    __classPrivateFieldSet(this, _PICSelector_onlyRunThisOnceTheSecond, true, "f");
                }
            }
            //The internal select element reports multiple values split by ';'
            //Mark all options with fittings keys as selected and set the submitvalue
            else if (this.selectType_ === 'selectmultiple' && this.value.indexOf(';') > -1) {
                const splitValues = this.value.split(';');
                for (let option of this.selectorElem.options) {
                    if (splitValues.includes(option.value))
                        option.selected = true;
                }
                let selOptions = this.selectorElem.selectedOptions;
                this.submitVal_ = '';
                for (let i = 0; i < selOptions.length; i++) {
                    this.submitVal_ += ((_a = selOptions[i]) === null || _a === void 0 ? void 0 : _a.value) + ';';
                }
                this.submitVal_ = this.submitVal_.slice(0, -1);
                __classPrivateFieldSet(this, _PICSelector_onlyRunThisOnceTheSecond, true, "f");
            }
        }
        if (this.inputField) {
            let p = this.inputField.querySelector('p');
            if (p && p.offsetWidth > 0 && p.offsetWidth < p.scrollWidth)
                this.hasEllipsis = true;
            else
                this.hasEllipsis = false;
        }
        //For multiselect, porperly initialize the submitval so submitvalue can return the empty string if removed
        if (!__classPrivateFieldGet(this, _PICSelector_onlyRunThisOnce, "f") && this.eType !== 'old' && this.selectType_ === 'selectmultiple' && !this.submitVal_ && this.selectedOption) {
            this.submitVal_ = this.selectedOption.key;
            __classPrivateFieldSet(this, _PICSelector_onlyRunThisOnce, true, "f");
        }
    }
    // Handles hide options on browser resize
    firstUpdated(_changedProperties) {
        if (this.eType !== 'old')
            super.firstUpdated(_changedProperties);
        if (this.alignRight_) {
            this.style.marginLeft = 'auto';
            this.style.marginRight = '12px';
        }
        window.addEventListener("resize", () => {
            if (this.menu && !this.menu.isHidden)
                this.forceClose();
        });
        this.requestUpdate();
    }
    focus() {
        this.inputField.focus();
    }
    dataReady() {
        if (this.value) {
            if (this.value.length > 0) {
                let ref = this;
                setTimeout(() => {
                    if (ref.optionContainer.getOption(ref.value))
                        ref.selectedOption = ref.optionContainer.getOption(ref.value);
                    ref.requestUpdate();
                }, 20);
            }
        }
    }
    getInnerInputClass() {
        let tmp = super.getInnerInputClass();
        if (this.menu) {
            tmp['arrowup'] = !this.menu.isHidden && this.selectType_ !== 'selectmultiple';
            tmp['arrowdown'] = this.menu.isHidden && this.selectType_ !== 'selectmultiple';
        }
        else {
            tmp['arrowdown'] = this.selectType_ !== 'selectmultiple';
        }
        tmp['disabled'] = this.disabled_ && this.eType !== 'old';
        tmp['textoverflow'] = true;
        tmp['invalid'] = this.validState.length > 0;
        return tmp;
    }
    renderMenuSpinner() {
        var _a, _b;
        let txtCont = ((_b = (_a = this.selectedOption_) === null || _a === void 0 ? void 0 : _a.val) !== null && _b !== void 0 ? _b : '') !== ''
            ? this.selectedOption_.val
            : (this.placeholder !== '' ? this.placeholder : html `&nbsp;`);
        //if text is overflowing, add pictooltip
        let tt = this.selectedOption_ ? this.selectedOption_.val.length * 9 > parseInt(this.width.replace(/[^0-9]/g, '')) : false;
        if (this.density == 'inline')
            return html `
                ${this.renderCSS(true)}
                <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())}>
                    <label @click=${this.menuSpinnerFocusHandler} class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${this.id}>${this.label}</label>
                    <div class="inline-column">
                        <div 
                            tabindex=${this.disabled_ ? '-1' : '0'} 
                            class=${classMap(this.getInnerInputClass())}
                            id=${this.id}
                            @click=${this.menuSpinnerFocusHandler}
                            @focusin=${() => this.focusHandler('in')}
                            @focusout=${(e) => { this.focusHandler('out'); }}
                            @keydown=${(e) => this.keyHander(e)}>
                            <p>
                                ${txtCont}
                            </p>
                            ${txtCont ? html `<pic-tooltip>${txtCont}</pic-tooltip>` : ''}
                        </div>
                        <pic-menu .parent=${this} .parentInputOptions=${this.options} .rows=${this.rows_} .width=${this.width}></pic-menu>
                    </div>
                </div>
                ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
                ${this.renderErr(this.showFullError)}
            `;
        else
            return html `
                ${this.renderCSS(true)}
                <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())}>
                    <label 
                        @click=${this.menuSpinnerFocusHandler}
                        class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} 
                        for=${this.id}
                        >
                        ${this.label}
                    </label>
                    <div 
                        tabindex=${this.disabled_ ? '-1' : '0'} 
                        class=${classMap(this.getInnerInputClass())} 
                        id=${this.id} 
                        @click=${this.menuSpinnerFocusHandler}
                        @focusin=${() => this.focusHandler('in')}
                        @focusout=${(e) => { this.focusHandler('out'); }}
                        @keydown=${(e) => this.keyHander(e)}
                        >
                        <p>
                            ${txtCont}
                        </p>
                    </div>
                    ${this.renderErr(this.showFullError)}
                    <pic-menu .parent=${this} .parentInputOptions=${this.options} .rows=${this.rows_} .width=${this.width}></pic-menu>
                </div>
                ${this.tooltip_ ?
                html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` :
                txtCont && this.hasEllipsis ?
                    html `<pic-tooltip>${txtCont}</pic-tooltip>` :
                    ''}
            `;
    }
    renderMultiSelectSpinner() {
        const heightClass = { 'height': this.rows_ * 1.35 + 'rem' };
        const oldStyle = html `<style>${this.getOldCSSStyle()}</style>`;
        return html `
            ${this.renderCSS(true)}
            ${oldStyle}
            <div style=${styleMap(this.getContainerStyle())} class="container">
                <label class=${classMap(this.getInputLabelClass())} for=${this.id}>${this.label}</label>
                <select 
                    style=${styleMap(heightClass)}
                    class=${classMap(this.getInnerInputClass())}
                    name=${this.id} 
                    id="inner_selector" 
                    ?disabled=${this.disabled_}
                    ?multiple=${true} 
                    @change=${this.handleSpinnerChange}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.focusHandler('out'); }}
                    @keydown=${this.oldHandleKeyDown}>
                    ${repeat(this.options, (item, index) => this.renderOption(item, index, true))}
                </select>
                ${this.renderErr(this.showFullError)}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
    getOldCSSStyle() {
        return css `
            :host{
                --pic-optionHoverColor: 
                    linear-gradient(to right, var(--pic-primaryHoverColor), var(--pic-primaryHoverColor)),
                    linear-gradient(to right, var(--pic-surfaceColor), var(--pic-surfaceColor));
                --pic-selectedOptionBGColor: 
                    linear-gradient(to right, var(--pic-primaryFocusColor), var(--pic-primaryFocusColor)),
                    linear-gradient(to right, var(--pic-surfaceColor), var(--pic-surfaceColor));
            }
            .inner-input-default.low > option:first-of-type {
                margin-top: calc(var(--pic-densityLowLabelHeight) / 2);
            }
            .inner-input-default.medium > option:first-of-type {
                margin-top: calc(var(--pic-densityMediumLabelHeight) / 2);
            }
            .inner-input-default.high > option:first-of-type {
                margin-top: calc(var(--pic-densityHighLabelHeight) / 2);                
            }
            .inner-input-default.inline > option:first-of-type {
                margin-top: calc(var(--pic-densityInlineLabelHeight) / 2);                
            }
            .inner-input.disabled > option:first-of-type{
                pointer-events: none;
                color: var(--pic-disabledColor);
            }
            .inner-input > option {
                color: var(--pic-onSurfaceHighColor);
                /* cursor: pointer; */
            }
            .inner-input > option:checked {
                background-color: unset;
                background-image: var(--pic-selectedOptionBGColor);
                -webkit-text-fill-color: var(--pic-onSurfaceHighColor);
                -moz-text-fill-color: var(--pic-onSurfaceHighColor);
            }
            .inner-input > option:hover {
                background-color: unset;
                background-image: var(--pic-optionHoverColor);
            }
            option.subval-option {
                z-index: 2; /* tmp fix, better visually, but can't click */
            }
        `;
    }
    render() {
        this.setComponentInlineStyle();
        if (this.eType == 'old') {
            switch (this.selectType_) {
                case 'spinner':
                    return this.renderSpinner();
                case 'selectmultiple':
                    return this.renderSpinner('multiple');
                default:
                    return this.renderSpinner();
            }
        }
        else if (this.eType == 'selection') {
            switch (this.selectType_) {
                case 'spinner':
                    return this.renderMenuSpinner();
                case 'selectmultiple':
                    return this.renderMultiSelectSpinner();
                default:
                    return this.renderMenuSpinner();
            }
        }
        else {
            return this.renderMenuSpinner();
        }
    }
};
_PICSelector_onlyRunThisOnce = new WeakMap();
_PICSelector_onlyRunThisOnceTheSecond = new WeakMap();
PICSelector.arrowUp = false;
__decorate([
    query('#inner_selector')
], PICSelector.prototype, "selectorElem", void 0);
__decorate([
    query('.inner-inputLabel')
], PICSelector.prototype, "inputLabel", void 0);
__decorate([
    query('.inner-input')
], PICSelector.prototype, "inputField", void 0);
__decorate([
    property({ reflect: true, attribute: 'selecttype', converter: stringDecoder })
], PICSelector.prototype, "selectType_", void 0);
__decorate([
    property({ reflect: true, attribute: 'rows', converter: numberDecoder })
], PICSelector.prototype, "rows_", void 0);
__decorate([
    property({ reflect: true, attribute: 'onlyvalid', converter: booleanDecoder })
], PICSelector.prototype, "onlyvalid_", void 0);
__decorate([
    property({ reflect: true, attribute: 'fitcontent', converter: booleanDecoder })
], PICSelector.prototype, "fitcontent_", void 0);
__decorate([
    property({ reflect: true, attribute: 'alignright', converter: booleanDecoder })
], PICSelector.prototype, "alignRight_", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'matchmode', converter: enumConverter(MatchMode, MatchMode.StartsWith) })
], PICSelector.prototype, "matchMode", void 0);
__decorate([
    property({ reflect: true, attribute: 'matchpriority', converter: enumConverter(MatchPriority, MatchPriority.None) })
], PICSelector.prototype, "matchPriority", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: ':userest' })
], PICSelector.prototype, "useRest", void 0);
__decorate([
    state()
], PICSelector.prototype, "hasEllipsis", void 0);
PICSelector = PICSelector_1 = __decorate([
    customElement('pic-selector')
], PICSelector);
export { PICSelector };
//# sourceMappingURL=PICSelector.js.map